import React from "react";
import { House, Buildings, ArrowRight, Users } from "@phosphor-icons/react";

export default function FinalCTA({ onBook }) {
  return (
    <section
      data-testid="final-cta-section"
      className="relative bg-zinc-950 text-white py-24 md:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 hero-grid opacity-40" />
      <div
        aria-hidden="true"
        className="absolute -bottom-32 -left-32 w-[28rem] h-[28rem] rounded-full"
        style={{
          background: "radial-gradient(closest-side, rgba(37,99,235,0.4), transparent 70%)",
          filter: "blur(20px)",
        }}
      />

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-[1.05]">
            Stop losing time to
            <span className="block text-blue-500">technology problems.</span>
          </h2>
          <p className="mt-5 text-lg text-zinc-300">
            Whether it&rsquo;s your home laptop or a 50-seat office network, we&rsquo;ll handle it.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-5 lg:gap-6 max-w-4xl mx-auto">
          {/* Residential */}
          <div
            data-testid="final-residential-card"
            className="relative bg-white/[0.04] border border-white/10 rounded-2xl p-8 hover:bg-white/[0.07] hover:border-blue-500/40 transition-all"
          >
            <div className="h-12 w-12 rounded-xl bg-blue-600/20 text-blue-300 grid place-items-center">
              <House size={24} weight="duotone" />
            </div>
            <div className="mt-5 text-xs font-semibold uppercase tracking-widest text-blue-300">Residential</div>
            <h3 className="mt-1 font-heading text-2xl font-bold text-white">For your home tech.</h3>
            <p className="mt-3 text-sm text-zinc-400 leading-relaxed">
              PC tune-ups, virus removal, data backup, hardware repair, Wi-Fi setup — same-day fixes.
            </p>
            <button
              onClick={() => onBook && onBook("")}
              data-testid="final-book-repair"
              className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full bg-blue-600 hover:bg-blue-700 text-white px-5 h-12 font-semibold transition-all"
            >
              Book Repair <ArrowRight size={16} weight="bold" />
            </button>
          </div>

          {/* Business */}
          <div
            data-testid="final-business-card"
            className="relative bg-white/[0.04] border border-white/10 rounded-2xl p-8 hover:bg-white/[0.07] hover:border-blue-500/40 transition-all"
          >
            <div className="h-12 w-12 rounded-xl bg-blue-600/20 text-blue-300 grid place-items-center">
              <Buildings size={24} weight="duotone" />
            </div>
            <div className="mt-5 text-xs font-semibold uppercase tracking-widest text-blue-300">Business</div>
            <h3 className="mt-1 font-heading text-2xl font-bold text-white">For your team.</h3>
            <p className="mt-3 text-sm text-zinc-400 leading-relaxed">
              Free IT assessment + custom Managed IT plan. From 3 to 500+ users, we scale with you.
            </p>
            <button
              onClick={() => onBook && onBook("Free Business IT Assessment")}
              data-testid="final-schedule-assessment"
              className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-full bg-white text-zinc-900 hover:bg-zinc-100 px-5 h-12 font-semibold transition-all"
            >
              Schedule IT Assessment <ArrowRight size={16} weight="bold" />
            </button>
          </div>
        </div>

        {/* Phase 2 — 10+ employees custom proposal */}
        <div
          data-testid="ten-plus-cta"
          className="mt-14 relative max-w-4xl mx-auto rounded-2xl border border-blue-500/30 bg-blue-600/10 p-8 sm:p-10 flex flex-col md:flex-row items-start md:items-center gap-6"
        >
          <div className="h-14 w-14 shrink-0 rounded-2xl bg-blue-600 text-white grid place-items-center">
            <Users size={26} weight="duotone" />
          </div>
          <div className="flex-1">
            <h3 className="font-heading text-2xl font-bold text-white">Need IT for 10 or more employees?</h3>
            <p className="mt-2 text-zinc-300 text-[15px] leading-relaxed">
              Every business is different. Schedule a free consultation and receive a custom Managed
              IT proposal tailored to your environment.
            </p>
          </div>
          <button
            onClick={() => onBook && onBook("Custom MSP Proposal — 10+ Users")}
            data-testid="ten-plus-cta-btn"
            className="shrink-0 inline-flex items-center gap-2 rounded-full bg-blue-600 hover:bg-blue-700 text-white px-6 py-3.5 font-semibold blue-glow transition-all"
          >
            Get My Custom Proposal <ArrowRight size={16} weight="bold" />
          </button>
        </div>
      </div>
    </section>
  );
}
